if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
            // custom code START
            console.log("lllll");
            autoCheckGiftInCart();
            getCartAndFixShippingProtection();
            setTimeout(()=>{
                      initializeCartSliderQtyChange_prodform();
                      },2000);

          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}




// #########################################  CUSTOM SCRIPT ##########################################
function autoCheckGiftInCart() {
  fetch(`/cart.js`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' }
  })
    .then(response => response.text())
    .then(state => {
      const parsedState = JSON.parse(state);
      console.log("🛒 Cart items:", parsedState.items);
      console.log("🔢 Total quantity:", parsedState.item_count);
      autoAddProduct(parsedState);
       if (parsedState.item_count === 0 ) {
                  setTimeout(() => {
                  renderRecentlyViewedProducts();
                  console.log("should show recent review");
                  }, 1000);
                  }
    })
    .catch(err => console.error('Error fetching cart:', err));
}


// ========================
// AUTO ADD / REMOVE GIFTS
// ========================
function autoAddProduct(parsedState) {
  const rows = document.querySelectorAll('tbody.gift-product-body tr[data-autoadd="true"]');
  if (!rows.length) {
    console.log("No auto-add rows found");
    return;
  }

  const cartTotalCustom = parsedState.original_total_price / 100;
  const itemsToAdd = [];
  const itemsToRemove = [];

  // rows.forEach(tr => {
  //   const autoProdId = parseInt(tr.getAttribute("data-prodid"));
  //   const autoProdThreshold = parseInt(tr.getAttribute("data-threeshhold"));
  //   if (!autoProdId || !autoProdThreshold) return;

  //   const freeProductInCart = parsedState.items.find(item => item.id === autoProdId);

  //   if (cartTotalCustom >= autoProdThreshold) {
  //     if (!freeProductInCart) {
  //       itemsToAdd.push({ id: autoProdId, quantity: 1 });
  //     } else if (freeProductInCart.quantity > 1) {
  //       updateFromCart(freeProductInCart.key, 1);
  //     }
  //   } else if (freeProductInCart) {
  //     itemsToRemove.push(freeProductInCart.key);
  //   }
  // });
    rows.forEach(tr => {
  const autoProdId = parseInt(tr.getAttribute("data-prodid"));
  const autoProdThreshold = parseInt(tr.getAttribute("data-threeshhold"));
  if (!autoProdId || !autoProdThreshold) return;

  const freeProductInCart = parsedState.items.find(item => item.id === autoProdId);

  // If cart total meets or exceeds threshold
  if (cartTotalCustom >= autoProdThreshold) {
    if (!freeProductInCart) {
      // ✅ Add the gift if not already in cart
      itemsToAdd.push({
        id: autoProdId,
        quantity: 1
      });
    } else if (freeProductInCart.quantity > 1) {
      // ✅ Normalize quantity to 1 if multiple exist
      updateFromCart(freeProductInCart.key, 1);
    }
  } 
  // If cart total is less than threshold
  else {
    if (freeProductInCart) {
      // ✅ Remove this product since threshold not met
      itemsToRemove.push(freeProductInCart.key);
    }
  }
});

  console.log("🟢 Items to add product form.js:", itemsToAdd);
  console.log("🔴 Cart total product form.js :", cartTotalCustom);

  console.log("🔴 Items to remove product form.js :", itemsToRemove);

  if (itemsToAdd.length) addToCart(itemsToAdd);
  if (itemsToRemove.length) removeMultipleItems(itemsToRemove);
}





// ========================
// ADD TO CART
// ========================
function addToCart(items) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items })
  })
    .then(() => fetch(`${routes.cart_url}?section_id=cart-drawer`))
    .then(response => response.text())
    .then(responseText => {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const newCartDrawer = html.querySelector("cart-drawer");
      const currentCartDrawer = document.querySelector("cart-drawer");

      if (newCartDrawer && currentCartDrawer) {
        currentCartDrawer.replaceWith(newCartDrawer);
        newCartDrawer.classList.add("active");
        setTimeout(() => {
          refreshSideCart();
          console.log("🛍️ Cart updated after adding items");
        }, 1000);
      }
      autoCheckGiftInCart();
    });
}



// ========================
// UPDATE CART ITEM QUANTITY
// ========================
function updateFromCart(itemKey, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: itemKey, quantity: qty })
  })
    .then(() => fetch(`${routes.cart_url}?section_id=cart-drawer`))
    .then(response => response.text())
    .then(responseText => {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const newCartDrawer = html.querySelector("cart-drawer");
      const currentCartDrawer = document.querySelector("cart-drawer");

      if (newCartDrawer && currentCartDrawer) {
        currentCartDrawer.replaceWith(newCartDrawer);
        newCartDrawer.classList.add("active");
        setTimeout(() => {
          refreshSideCart();
          console.log("🔄 Cart updated after quantity change");
        }, 1000);
      }
      autoCheckGiftInCart();
    });
}



// ========================
// REMOVE MULTIPLE ITEMS
// ========================
function removeMultipleItems(keys = []) {
  if (!keys.length) return;

  const updates = {};
  keys.forEach(key => updates[key] = 0);

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates })
  })
    .then(res => res.json())
    .then(updatedCart => {
      console.log('🧹 Removed multiple items:', keys);
      console.log('🆕 Updated cart:', updatedCart);
      refreshSideCart();
      autoCheckGiftInCart();
    })
    .catch(err => console.error('Multi-remove failed:', err));
}


 function refreshSideCart() {    
  fetch("https://www.baiia.com.au/cart?section_id=cart-drawer")
  .then(res => res.text())
  .then(html => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    const newDrawer = doc.querySelector("cart-drawer");
    newDrawer.classList.add("appended-drawer");
    const totalQty = parseInt(newDrawer?.getAttribute("data-totalqty") || "0", 10);
    updateCartBubble(totalQty);
    !newDrawer.classList.contains("active") && newDrawer.classList.add("active");
    const existingDrawer = document.querySelector("cart-drawer");
    if (newDrawer && existingDrawer) 
        {
            existingDrawer.replaceWith(newDrawer);
            initializeCartSlider();
        }
    
  });
   }

function initializeCartSlider() {
    const drawer = document.querySelector(".drawer__inner-complete-items");
    const swiperContainer = drawer?.querySelector(".cart-items.swiper");
    if (swiperContainer) {
        // Check if already initialized
        if (swiperContainer.classList.contains("swiper-initialized")) {
            console.log("Swiper already initialized — destroying and reinitializing...");
            swiperContainer.swiper.destroy(true, true); // fully destroy existing swiper
        } else {
            console.log("Swiper not initialized — initializing...");
        }
        // Reinitialize Swiper
        new Swiper('.cart-items.swiper', {
            slidesPerView: 1,
            spaceBetween: 10,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            scrollbar: {
                el: '.swiper-scrollbar',
            },
            loop: false,
        });
    }
}


function updateCartBubble(totalQty) {
  const cartIcon = document.querySelector("#cart-icon-bubble");
  if (!cartIcon) return;

  // Remove any existing bubble first (clean slate)
  const existingBubble = cartIcon.querySelector(".cart-count-bubble");
  if (existingBubble) existingBubble.remove();

  // If there are items in the cart, create and insert bubble
  if (totalQty > 0) {
    const bubbleHTML = `
      <div class="cart-count-bubble">
        <span aria-hidden="true">${totalQty}</span>
        <span class="visually-hidden">${totalQty} item${totalQty > 1 ? "s" : ""}</span>
      </div>
    `;

    // Insert right before closing </a>
    cartIcon.insertAdjacentHTML("beforeend", bubbleHTML);
  }
}



// cart refresh on cart qty update START
function initializeCartSliderQtyChange_prodform() {
    const drawer = document.querySelector(".drawer__inner-complete-items");
    const swiperContainer = drawer?.querySelector(".cart-items.swiper");
    if (swiperContainer) {
        // Check if already initialized
        if (swiperContainer.classList.contains("swiper-initialized")) {
            console.log("from cart.js Swiper already initialized — destroying and reinitializing...");
            swiperContainer.swiper.destroy(true, true); // fully destroy existing swiper
        } else {
            console.log("Swiper not initialized — initializing...");
        }
        // Reinitialize Swiper
        new Swiper('.cart-items.swiper', {
            slidesPerView: 1,
            spaceBetween: 10,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            scrollbar: {
                el: '.swiper-scrollbar',
            },
            loop: false,
        });
    }
}



// custom function recently review item append in the side cart START
function renderRecentlyViewedProducts_fromFormjs() {
  const recentWrapper = document.querySelector("#recently-viewed-wrapper");
  const recentData = JSON.parse(localStorage.getItem("recently_viewed_full") || "[]");

  console.log(recentData.length);
  console.log(recentData);

  if (!recentData.length || !recentWrapper) {
    console.log("No recently viewed items found.");
    if(recentWrapper){
     recentWrapper.closest(".recently_viewed_outer").classList.add("hidden");
    }

    return;
  }

  const wrapper = recentWrapper;
  wrapper.innerHTML = ""; // Clear previous content

  recentData.forEach((item) => {
    let variantHTML = "";

    if (item.variants && item.variants.length > 1) {
      variantHTML = `
        <select class="rp-variant-select">
          ${item.variants
            .map(
              (v) =>
                `<option value="${v.id}" data-price="${(v.price / 100).toFixed(2)}">${v.title}</option>`
            )
            .join("")}
        </select>`;
    } else if (item.variants && item.variants.length === 1) {
      const v = item.variants[0];
      variantHTML = `<input type="hidden" class="rp-variant-select" value="${v.id}" data-price="${(
        v.price / 100
      ).toFixed(2)}">`;
    }

    const productHTML = `
      <div class="related-product swiper-slide" data-product-id="${item.id}">
        <div class="rp-image">
          <img width="100" height="150" src="${item.featured_image || item.images?.[0]}" alt="${item.title}">
        </div>
        <div class="rp-details">
          <h4>${item.title}</h4>
           <span class="size_lable_sidecart">Size</span>
          ${variantHTML}
          <button class="rp-add-btn-recent-review" data-product-title="${item.title}">ADD</button>
        </div>
        <div class="rp-price">$${(item.price / 100).toFixed(2)}</div>
      </div>
    `;

    wrapper.insertAdjacentHTML("beforeend", productHTML);
  });

  console.log("✅ Recently viewed products rendered!");

  // Initialize Swiper after rendering
  new Swiper(".cart-items.swiper", {
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    scrollbar: {
      el: ".swiper-scrollbar",
    },
    loop: false,
  });
}





 function getShippingProtectionData(cart_total) {
      for (const level of window.shippingProtectionLevels) {
          if (cart_total <= level.max) {
              return level;
          }
      }
      return null;
  }


 async function fixShippingProtection(parsedState) {
  const cartTotal = (parsedState.total_price / 100).toFixed(2);

  // 1. Get correct protection level for this cart total
  const return_level_var = getShippingProtectionData(cartTotal);
  if (!return_level_var || !return_level_var.variant) {
    console.warn("No return level found");
    return;
  }

  const correctVariantId = return_level_var.variant;

  // 2. Find all shipping protection items currently in cart
  const matchedItems = parsedState.items.filter(
    item => item.product_id == window.shippingProtectionProduct
  );

  console.log("Matched shipping protection items:", matchedItems);

  // 3. Remove all WRONG shipping protection variants
  for (const item of matchedItems) {
    if (item.id != correctVariantId) {
      console.log("Removing wrong variant:", item.id);
      await fetch(`/cart/change.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      });
    }
  }

  // 4. Check if the correct variant exists after removals
  const stillInCart = matchedItems.some(item => item.id == correctVariantId);

  // 5. If correct variant missing → add correct variant
  if (!stillInCart) {
    console.log("Adding correct protection:", correctVariantId);
    await fetch(`/cart/add.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: correctVariantId,
        quantity: 1
      })
    });
  }

  console.log("Shipping protection fixed.");
  refreshSideCart_cartjs();
}



 function refreshSideCart_cartjs() {    
  fetch("https://www.baiia.com.au/cart?section_id=cart-drawer")
  .then(res => res.text())
  .then(html => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    const newDrawer = doc.querySelector("cart-drawer");
    newDrawer.classList.add("appended-drawer");
    const totalQty = parseInt(newDrawer?.getAttribute("data-totalqty") || "0", 10);
    updateCartBubble(totalQty);
    !newDrawer.classList.contains("active") && newDrawer.classList.add("active");
    const existingDrawer = document.querySelector("cart-drawer");
    if (newDrawer && existingDrawer) 
        {
            existingDrawer.replaceWith(newDrawer);
            // initializeCartSlider();
        }
    
  });
   }